export default __webpack_public_path__ + "static/media/m365.e116a418.svg";